import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import {
    Box,
    Button,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import {Close} from "@mui/icons-material";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogContentComponent from "../../../common/components/Shared/DialogContentComponent";
import useApi from "../../../api/useApi";
import Row from "./Row";
import {currencyFormat} from "../../../common/formatters/format";
import useNotification from "../../../common/components/hooks/useNotification";
import FieldCalendar from "../../../common/components/forms/fields/FieldCalendar";
import {getTodayIsoString} from "../../../common/utility/dateUtility";
const AutorizacionesDialog = ({open, onClose, facturas}) => {
    const {t} = useTranslation();
    const api = useApi('configuracion/facturas');
    const apiAutorizacion = useApi('configuracion/flujoFacturacion');
    const notification = useNotification();
    const[data, setData] = useState([facturas]);
    const fechaActual = getTodayIsoString();

    useEffect(() => {
        if(open){
            load()}
        // eslint-disable-next-line
    }, [open]);

    const load = async () => {
        if(facturas.length === 0){
            notification.warning(t('Selecciona al menos un registro'));
            return;
        }
        const response = await api.post('agruparFacturas',{'facturaIds':facturas}, {showSuccess:false})
        setData(response);
    }

    const changeDate = (value, field) => {
        data['fechaRealPago'] = value;
    }

    const cerrar = () => {
        onClose();
    }

    const desagruparFactura = (consecutivo, row) => {
        const newData = data;
        //se obtiene los index necesarios
        const indexPadre = data.findIndex(i => i.consecutivo === consecutivo);
        const maxConsecutivo = Math.max(...data?.map(e => e.consecutivo));
        const indexFacturaAgrupada = data[indexPadre].agrupados?.findIndex(a => a.id === row.id);

        // se agrega un consecutivo a la fila a desagrupar
        row['consecutivo'] = maxConsecutivo +1;
        row['agrupados'] = [];

        //se desagrupa la factura
        newData[indexPadre]?.agrupados?.splice(indexFacturaAgrupada,1);

        //se resta el monto total de la agrupacion de facturas
        newData[indexPadre].monto = (newData[indexPadre]?.monto - row.monto);

        //se agrega la nueva factura desagrupada
        newData?.splice(maxConsecutivo + 1,0, row);

        //verificamos si el grupo de agrupadas esta vacio o no
        //si esta vacio eliminamos el grupo de facturas agrupadas
        if(newData[indexPadre]?.agrupados?.length === 0){
            newData?.splice(indexPadre,1);
        }

        //se guarda el nuevo arreglo
        setData([...newData]);
    }

    const eliminarFactura = (esPadre, consecutivo,row) => {
        const newData = data;
        const indexPadre = data.findIndex(i => i.consecutivo === consecutivo);
        const indexFacturaAgrupada =  data[indexPadre].agrupados?.findIndex(a => a.id === row.id);

        if(esPadre){
            newData?.splice(indexPadre,1);
        }else{
            newData[indexPadre]?.agrupados?.splice(indexFacturaAgrupada,1);
            //se resta el monto total de la agrupacion de facturas
            newData[indexPadre].monto = (newData[indexPadre]?.monto - row.monto);
            //verificamos si el grupo de agrupadas esta vacio o no
            //si esta vacio eliminamos el grupo de facturas agrupadas
            if(newData[indexPadre]?.agrupados?.length === 0){
                newData?.splice(indexPadre,1);
            }
        }

        //se guarda el nuevo arreglo
        setData([...newData]);
    }

    const autorizarFacturas = async(esAutorizacion, comentarios) =>{
        let FacturasId = '';
        data?.filter((row) => row.agrupados.length === 0 ).forEach((index, row) => FacturasId += `${index.id}-0|`);
        data?.map((row, index)=> row.agrupados.map(f => FacturasId += `${f.id}-${index+1}|`));
        FacturasId = FacturasId.slice(0,-1);
        if(FacturasId === ''){
            notification.warning(t('Favor de seleccionar facturas'));
            return;
        }

        const fechaRealPago = esAutorizacion ? data['fechaRealPago'] : new Date().toJSON();
        if (esAutorizacion && isNaN(Date.parse(data['fechaRealPago']))) {
            notification.warning(t('Seleccione una fecha correcta'));
            return;
        }

        await apiAutorizacion.post('autorizacionMasiva', {
            FacturasId,
            esAutorizacion,
            comentarios,
            fechaRealPago
        }, {showLoading: true});

        cerrar();
    }

    return(
        <Dialog
            open={open}
            fullWidth={true}
            maxWidth={'lg'}>
            <DialogTitle marginInline={4} marginTop={2} fontWeight={'bold'}>
                {t('Resúmen de Autorización')}
                <IconButton sx={{position: 'absolute', right: 8, top: 8}} onClick={() => cerrar()}>
                    <Close/>
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{marginInline: 4}}>
                <DialogContentComponent>
                    <Box sx={{ display: 'flex', flexDirection: 'row', fontWeight: 'bold', fontSize:'larger', paddingBlock:'20px'}}>
                        {t('Facturas por autorizar')}
                    </Box>
                    <TableContainer sx={{height:400 }}>
                        <Table aria-label="sticky collapsible table" stickyHeader size={'small'}>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{width: 50}}/>
                                    <TableCell align="left" sx={{fontWeight:'bold', width: 50}}>{t('Factura')}</TableCell>
                                    <TableCell align="left" sx={{fontWeight:'bold', width: 250}}>{t('Proveedor')}</TableCell>
                                    <TableCell align="left" sx={{fontWeight:'bold', width: 150}}>{t('RFC')}</TableCell>
                                    <TableCell align="left" sx={{fontWeight:'bold', width: 100}}>{t('Fecha Prog. Pago')}</TableCell>
                                    <TableCell align="left" sx={{fontWeight:'bold', width: 50}}>{t('Moneda')}</TableCell>
                                    <TableCell align="right" sx={{fontWeight:'bold', width: 150}}>{t('Monto')}</TableCell>
                                    <TableCell sx={{width: 50}}/>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data?.map((row, index) => (
                                    // <Row key={row.consecutivo + row.id} props={row} desagrupar={desagruparFactura} eliminar={eliminarFactura}/>
                                    <Row key={index} props={row} desagrupar={desagruparFactura} eliminar={eliminarFactura}/>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box sx={{ display: 'flex', flexDirection: 'row-reverse', fontWeight: 'bold', fontSize:'larger', paddingInline:'75px', paddingBlock:'20px', color:'primary.main'}}>
                        {t('Monto Total por autorizar  ')}{currencyFormat(data?.reduce((a, b) => a + (b['monto'] || 0),0))}
                    </Box>
                </DialogContentComponent>
                <DialogActions>
                    <Box sx={{display: "grid", gridAutoColumns: "1fr", width: "100%", gap: "10px"}}>
                        <Box textAlign={'left'} color={'black'} fontWeight={'bold'}
                             sx={{gridRow: "1", gridColumn: "1/8"}}>
                            <label className={'title'}>{t('FECHA REAL DE PAGO')}</label>
                        </Box>
                        <Box textAlign={'left'} color={'black'} fontWeight={'bold'}
                             sx={{gridRow: "1", gridColumn: "3/8"}}>
                            <FieldCalendar value={data?.fechaRealPago} field={data?.fechaRealPago} minDate={fechaActual}
                                           onChange={changeDate}/>
                        </Box>
                        <Box textAlign={'right'} color={'black'} fontWeight={'bold'}
                             sx={{gridRow: "1", gridColumn: "8/8"}}>
                            <Button  variant="outlined" color={'inherit'} onClick={() => cerrar()}>
                                {t('CANCELAR')}
                            </Button>
                        </Box>
                        <Box textAlign={'right'} color={'black'} fontWeight={'bold'} sx={{gridRow: "1", gridColumn: "8/10"}} >
                            <Button  variant="outlined" color={'info'} onClick={() => autorizarFacturas(true, '')}>
                                {t('Autorizar')}
                            </Button>
                        </Box>
                    </Box>
                </DialogActions>
            </DialogContent>
        </Dialog>
    )
}

export default AutorizacionesDialog;
